<template>
    <div class="flex flex-col gap-y-2">
        <div class="flex justify-between">
            <label :for="name" class="text-white font-bold" v-text="title"></label>
            <slot name="accessory"></slot>
        </div>
        <slot></slot>
        <div v-if="hasInfoText" class="text-base text-cool-gray"><slot name="info"></slot></div>
    </div>
</template>

<script>
export default {
  inheritAttrs: false
}
</script>

<script setup>
import { useSlots, computed } from 'vue';

defineProps({
    name: {
        type: String,
        required: false
    },
    title: {
        type: String,
        required: true
    }
});

const slots = useSlots();
const hasInfoText = computed(() => !!slots.info);
</script>